module.exports = __webpack_public_path__ + "img/footer_back.d0a50e8f.png";